/**
 * To ISO string ignoring timezone
 * @example toISOStringLocal(new Date('2024-06-17T21:00:00.000Z')) // '2024-06-17'
 * @param d date
 * @returns string
 */
const toISOStringLocal = (d: Date) => {
  /**
   * Get a number, padding with a leading zero if necessary to get two charaters.
   * @param n
   */
  const z = (n: number) => ('0' + n).slice(-2);
  return d.getFullYear() + '-' + z(d.getMonth() + 1) + '-' + z(d.getDate());
};
export default toISOStringLocal;
